var _defs, _g;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgIconEyeGraphics = function SvgIconEyeGraphics(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_1989",
    "data-name": "Ret\\xE2ngulo 1989",
    width: 44,
    height: 27,
    transform: "translate(-0.486 0.33)",
    fill: "#4b4b4b",
    stroke: "#4b4b4b",
    strokeWidth: 0.5
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_5677",
    "data-name": "Grupo 5677",
    transform: "translate(-517 -423)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ret\\xE2ngulo_1974",
    "data-name": "Ret\\xE2ngulo 1974",
    transform: "translate(517 423)",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 1,
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("rect", {
    width: 50,
    height: 50,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 49,
    height: 49,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_5681",
    "data-name": "Grupo 5681",
    transform: "translate(520.305 435.1)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_5682",
    "data-name": "Grupo 5682",
    transform: "translate(0.181 -0.431)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_4588",
    "data-name": "Caminho 4588",
    d: "M21.712,26.778C9.843,26.778,0,15.416,0,13.389S9.843,0,21.712,0C33.437,0,43.425,11.942,43.425,13.389c0,1.954-10.132,13.389-21.712,13.389M1.447,13.389c.434,1.737,9.336,11.942,20.265,11.942,10.784,0,19.469-10.2,20.265-11.942-.868-1.737-9.626-11.942-20.265-11.942-10.784,0-19.758,10.2-20.265,11.942",
    transform: "translate(-0.199 0.441)",
    fill: "#4b4b4b",
    stroke: "#4b4b4b",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_4589",
    "data-name": "Caminho 4589",
    d: "M134.685,59.37A8.711,8.711,0,0,1,126,50.685a9.55,9.55,0,0,1,.434-2.823,8.754,8.754,0,0,1,12.738-4.632l-.724,1.23a7.722,7.722,0,0,0-3.763-1.013,7.238,7.238,0,0,0-6.876,4.922,8.152,8.152,0,0,0-.362,2.316,7.237,7.237,0,1,0,14.475,0,7.128,7.128,0,0,0-.217-1.737c-.072-.217-.072-.362-.145-.579l1.375-.434.217.651a10.351,10.351,0,0,1,.217,2.1,8.711,8.711,0,0,1-8.685,8.685Z",
    transform: "translate(-113.171 -37.216)",
    fill: "#4b4b4b",
    stroke: "#4b4b4b",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_4590",
    "data-name": "Caminho 4590",
    d: "M184.895,103.79A2.9,2.9,0,0,1,182,100.895a4.244,4.244,0,0,1,.145-.941A2.964,2.964,0,0,1,184.895,98a2.894,2.894,0,0,1,2.75,1.954,3.67,3.67,0,0,1,.145.941,2.9,2.9,0,0,1-2.9,2.895Zm0-4.342a1.39,1.39,0,0,0-1.375,1.013.919.919,0,0,0-.072.434,1.447,1.447,0,1,0,2.895,0,.919.919,0,0,0-.072-.434A1.39,1.39,0,0,0,184.895,99.447Z",
    transform: "translate(-163.381 -87.427)",
    fill: "#4b4b4b",
    stroke: "#4b4b4b",
    strokeWidth: 0.5
  }))))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIconEyeGraphics, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icon-eye-graphics.3ddf6044.svg";
export { ForwardRef as ReactComponent };